import clsx from 'clsx';
import styles from './ProgressNumber.module.css';

function ProgressNumber({ total, current, className, ...rest }) {
    return (
        <div {...rest} className={clsx(styles.wrapper, className)}>
            <div className={clsx(styles.current)}>{current}</div>
            <div className={clsx(styles.plash)}>/</div>
            <div className={clsx(styles.total)}>{total}</div>
        </div>
    );
}
export default ProgressNumber;
